export function newClientToken(): string {
  return crypto.randomUUID();
}
